(function () {
  if (window.__lodaPersonalization) return;
  window.__lodaPersonalization = true;

  var MAX_CHARS = 3;   // Zeichen pro Tasche
  var MAX_BAGS = 6;    // maximale Anzahl Felder
  var texts = [];      // Text pro Tasche (bleibt erhalten, auch wenn das Theme den Block neu rendert)
  var active = 0;      // Tasche, die in der Vorschau gezeigt wird
  var scheduled = false;

  for (var n = 0; n < MAX_BAGS; n++) texts.push('');

  function getForm() {
    return document.querySelector('form[id^="product-form-"]');
  }

  function getQuantity() {
    var form = getForm();
    if (!form) return 1;
    var q = parseInt(new FormData(form).get('quantity'), 10);
    if (isNaN(q) || q < 1) q = 1;
    return Math.min(q, MAX_BAGS);
  }

  function currentVariantId() {
    var form = getForm();
    if (!form) return null;
    var id = new FormData(form).get('id');
    return id ? String(id) : null;
  }

  // Erlaubt: Buchstaben (inkl. Ä, Ö, Ü) und Zahlen. Alles andere wird entfernt.
  function sanitize(value) {
    return String(value || '').replace(/[^A-Za-zÄÖÜäöü0-9]/g, '').toUpperCase().slice(0, MAX_CHARS);
  }

  function buildRow(i, qty) {
    var row = document.createElement('div');
    row.className = 'personalization-field';
    var id = 'personalization-input-' + i;

    if (qty > 1) {
      var label = document.createElement('label');
      label.className = 'personalization-field__label';
      label.setAttribute('for', id);
      label.textContent = 'Tasche ' + (i + 1);
      row.appendChild(label);
    }

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.className = 'personalization-block__input';
    input.dataset.index = String(i);
    input.maxLength = MAX_CHARS;
    input.placeholder = 'z. B. ABC';
    input.autocomplete = 'off';
    input.setAttribute('autocapitalize', 'characters');
    input.spellcheck = false;
    input.setAttribute('aria-label', qty > 1 ? 'Personalisierung Tasche ' + (i + 1) : 'Personalisierung');
    row.appendChild(input);
    return row;
  }

  function buildTab(i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'personalization-tab';
    b.dataset.index = String(i);
    b.textContent = 'Tasche ' + (i + 1);
    return b;
  }

  // Felder, Reiter und Vorschau an Menge und Eingaben angleichen (ändert das DOM nur bei Bedarf)
  function render() {
    var block = document.querySelector('.personalization-block');
    if (!block) return;

    var holder = block.querySelector('.personalization-fields');
    var preview = block.querySelector('.personalization-preview');
    var tabs = block.querySelector('.personalization-preview__tabs');
    var perBag = block.querySelector('.personalization-block__perbag');
    var qty = getQuantity();

    if (active >= qty) active = qty - 1;
    if (active < 0) active = 0;

    if (perBag && perBag.hidden !== (qty < 2)) perBag.hidden = qty < 2;

    // Ein Eingabefeld pro Tasche
    if (holder) {
      if (holder.querySelectorAll('.personalization-field').length !== qty) {
        holder.textContent = '';
        for (var i = 0; i < qty; i++) holder.appendChild(buildRow(i, qty));
      }
      holder.querySelectorAll('.personalization-block__input').forEach(function (input, idx) {
        if (input.value !== texts[idx] && document.activeElement !== input) input.value = texts[idx];
      });
    }

    // Reiter für die Vorschau (nur bei mehr als einer Tasche)
    if (tabs) {
      var wanted = qty > 1 ? qty : 0;
      if (tabs.children.length !== wanted) {
        tabs.textContent = '';
        for (var t = 0; t < wanted; t++) tabs.appendChild(buildTab(t));
      }
      if (tabs.hidden !== (wanted === 0)) tabs.hidden = wanted === 0;
      Array.prototype.forEach.call(tabs.children, function (btn, idx) {
        var on = idx === active;
        if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
        if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
      });
    }

    // Vorschau
    if (preview) {
      var images = {};
      try { images = JSON.parse(block.dataset.variantImages); } catch (e) {}
      var src = images[currentVariantId()] || Object.values(images).find(Boolean) || null;

      var img = preview.querySelector('img');
      var span = preview.querySelector('.personalization-preview__text');
      var text = texts[active] || '';

      if (src && img && img.getAttribute('src') !== src) img.setAttribute('src', src);
      if (span && span.textContent !== text) span.textContent = text;

      var anyText = texts.slice(0, qty).some(function (v) { return v; });
      var hide = !(anyText && src);
      if (preview.hidden !== hide) preview.hidden = hide;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      render();
    });
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('personalization-block__input')) {
      var i = parseInt(t.dataset.index, 10) || 0;
      var pos = t.selectionStart;
      var clean = sanitize(t.value);
      if (clean !== t.value) {
        t.value = clean;
        try { t.setSelectionRange(Math.min(pos, clean.length), Math.min(pos, clean.length)); } catch (err) {}
      }
      texts[i] = clean;
      active = i;
      render();
    } else {
      schedule(); // z. B. Mengenauswahl hat die Menge geändert
    }
  });

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('personalization-block__input')) {
      var i = parseInt(t.dataset.index, 10) || 0;
      if (active !== i) { active = i; render(); }
    }
  });

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.personalization-tab');
    if (tab) {
      active = parseInt(tab.dataset.index, 10) || 0;
      render();
    }
  });

  ['change', 'variant:change', 'product:variant-change'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(schedule, 50); });
  });
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  setInterval(schedule, 500); // Sicherheitsnetz für Änderungen ohne Event
  render();

  // --- Kalibrierung: Seite mit &pv-calibrate öffnen, ins Vorschaubild klicken ---
  if (location.search.indexOf('pv-calibrate') !== -1) {
    var showCal = function (stage) {
      var hint = document.querySelector('.personalization-preview__hint');
      var block = document.querySelector('.personalization-block');
      var cs = getComputedStyle(stage);
      if (hint) {
        hint.textContent = 'KALIBRIERUNG ' + (block ? block.dataset.handle : '') +
          ': pos_left = ' + parseFloat(cs.getPropertyValue('--pv-left')) +
          ', pos_top = ' + parseFloat(cs.getPropertyValue('--pv-top')) +
          ', pos_size = ' + parseFloat(cs.getPropertyValue('--pv-size'));
      }
    };

    document.addEventListener('click', function (e) {
      var stage = e.target.closest && e.target.closest('.personalization-preview__stage');
      if (!stage) return;
      var rect = stage.getBoundingClientRect();
      stage.style.setProperty('--pv-left', ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%');
      stage.style.setProperty('--pv-top', ((e.clientY - rect.top) / rect.height * 100).toFixed(1) + '%');
      showCal(stage);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== '+' && e.key !== '-') return;
      var stage = document.querySelector('.personalization-preview__stage');
      if (!stage || (e.target && e.target.tagName === 'INPUT')) return;
      var cur = parseFloat(getComputedStyle(stage).getPropertyValue('--pv-size')) || 5;
      stage.style.setProperty('--pv-size', (cur + (e.key === '+' ? 0.2 : -0.2)).toFixed(1));
      showCal(stage);
    });
  }

  // --- Warenkorb-Logik ---
  var originalFetch = window.fetch;
  var addingAddon = false;

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // Variant-ID aus dem Request des Themes lesen (FormData, URL-Parameter oder JSON)
  function getRequestVariantId(init) {
    var body = init && init.body;
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        return body.get('id') ? String(body.get('id')) : null;
      }
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var json = JSON.parse(body);
          if (json.id) return String(json.id);
          if (json.items && json.items[0]) return String(json.items[0].id);
        } else {
          var id = new URLSearchParams(body).get('id');
          return id ? String(id) : null;
        }
      }
    } catch (e) {}
    return null;
  }

  // Aktuelle Eingaben aus den Feldern lesen (falls z. B. Autofill ohne Input-Ereignis)
  function collectTexts() {
    document.querySelectorAll('.personalization-block__input').forEach(function (input) {
      var i = parseInt(input.dataset.index, 10);
      if (!isNaN(i) && i < MAX_BAGS) texts[i] = sanitize(input.value);
    });
    return texts;
  }

  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (!addingAddon && isCartAdd(url)) {
      var block = document.querySelector('.personalization-block');
      var form = getForm();

      if (block && form) {
        var formData = new FormData(form);
        var variantId = String(formData.get('id'));

        // Nur reagieren, wenn genau die Tasche der Produktseite hinzugefügt wird
        // (nicht z. B. Upsell-Produkte im Warenkorb)
        if (variantId && getRequestVariantId(init) === variantId) {
          var qty = Math.min(parseInt(formData.get('quantity'), 10) || 1, MAX_BAGS);
          var list = collectTexts().slice(0, qty).filter(Boolean);

          if (list.length) {
            var titles = {};
            try { titles = JSON.parse(block.dataset.variantTitles); } catch (e) {}
            var variantTitle = titles[variantId];
            var bagName = (variantTitle && variantTitle !== 'Default Title')
              ? block.dataset.productTitle + ' – ' + variantTitle
              : block.dataset.productTitle;

            // Pro ausgefülltem Feld eine Personalisierung (gleiche Texte fasst Shopify zusammen)
            var items = list.map(function (text) {
              return {
                id: parseInt(block.dataset.addonVariantId, 10),
                quantity: 1,
                properties: { 'Personalisierung': text, 'Für Tasche': bagName }
              };
            });

            addingAddon = true;
            try {
              var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              var res = await originalFetch.call(window, root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
              });
              if (!res.ok) throw new Error('Addon konnte nicht hinzugefügt werden');
            } catch (err) {
              console.error(err);
              addingAddon = false;
              alert('Die Personalisierung konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
              throw err;
            }
            addingAddon = false;
          }
        }
      }
    }

    return originalFetch.apply(this, arguments);
  };
})();